<template>
  <metric-grid :columns="3">
    <metric-card
        class="main-card"
        title="Your mention rate"
        info-title="Out of all tracked answers, how many mentioned your brand?"
        :value="summary.yourMentionRatePercent"
        suffix="%"
        :trend="summary.yourMentionRateTrendDisplay"
    >
      <template #description>
        <span class="ai-visibility-competitor-metrics__description-primary">
          You rank {{ summary.yourRankLabel }}
        </span>
        <span>
          {{ summary.yourMentionedAnswerCount }} of {{ summary.totalAnswerCount }} answers
        </span>
      </template>
    </metric-card>
    <metric-card
        title="Top competitor"
        info-title="This shows the competitor brand with the highest share of AI mentions."
        :value="summary.topCompetitorName"
        :description="`${summary.topCompetitorMentionRatePercent}% mention rate - ${summary.topCompetitorPositionLabel} position`"
        :trend="summary.topCompetitorMentionRateTrendDisplay"
    />
    <metric-card
        title="Competitors detected"
        info-title="This counts how many competitor brands AI mentioned across all tracked answers."
        :value="summary.totalCompetitors"
        :trend="summary.totalCompetitorsTrendDisplay"
    >
      <template #description>
        <span class="ai-visibility-competitor-metrics__description-primary">
          {{ summary.competitorsAheadCount }} beat you
        </span>
        <span>on at least one question</span>
      </template>
    </metric-card>
  </metric-grid>
</template>

<script>
import MetricGrid from '../../../ui/cards/MetricGrid.vue'
import MetricCard from '../../../ui/cards/MetricCard.vue'

export default {
  name: 'CompetitorMetrics',
  components: {
    MetricGrid,
    MetricCard,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-competitor-metrics__description-primary {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 500;
}

.ai-visibility-competitor-metrics__description-primary + span {
  margin-left: 4px;
  font-size: 16px;
  font-weight: 500;
}
</style>
